<template>
  <div class="prequal-checklist">
    <input v-model="search" class="search-input" type="text" placeholder="Search for a Qualification" @keyup.esc="resetSearch()" @keyup.enter="add(searchList[0] ? searchList[0].idx : null)">
    <div v-if="search.length == 0" class="toggle-dropdown">
      <i v-if="!showAll" class="material-icons" @click="showAll = !showAll">expand_more</i>
      <i v-else class="material-icons" @click="showAll = !showAll">expand_less</i>
    </div>
    <div v-else class="toggle-dropdown">
      <i class="material-icons" style="font-size: 12px;" @click="resetSearch()">clear</i>
    </div>
    <div v-if="search.length > 0" class="search-results">
      <div v-for="(option, idx) in searchList" :key="`results-${idx}`">
        <div v-if="!isSelected(option)" class="search-item" @click="add(option)">
          <i class="material-icons">add</i> {{ option }}
        </div>
      </div>
    </div>
    <div v-if="search.length == 0 && showAll" class="dropdown">
      <div v-for="(option, idx) in checkBoxOptionList" :key="`dropdown-${idx}`" :class="{ long: name == 'Parental Status' }" class="item" @click="toggle(option)">
        <i v-if="isSelected(option)" class="material-icons">check_box</i>
        <i v-else class="material-icons">check_box_outline_blank</i>
        {{ option }}
      </div>
    </div>
    <div v-else style="margin-top: 5px;" :class="{'display-buttons':!showAll}">
      <template v-for="(option, idx) in optionList">
        <div v-if="isSelected(option)" :key="`selected-${idx}`" class="selected-item" @click="remove(option)">
          <i class="material-icons" style="transition: none !important;">clear</i> {{ option }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    checkBoxFilter: {
      type: Array,
      required: false,
      default: () => []
    },
    name: {
      type: String,
      required: true
    },
    prePopulate: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {
      search: '',
      showAll: false,
      selected: []
    }
  },
  computed: {
    optionList: function () {
      if (typeof this.options[0] === 'object') {
        return this.options.map(o => o.title)
      } else {
        return this.options
      }
    },
    checkBoxOptionList: function () {
      if (this.checkBoxFilter.length === 0) return this.optionList
      return this.optionList.filter((option) => this.checkBoxFilter.includes(option))
    },
    abbrevDict: function () {
      if (typeof this.options[0] !== 'object') return {}
      return this.options.reduce(function (dict, option) {
        dict[option.title] = option.abbrev
        return dict
      }, {})
    },
    searchList: function () {
      var search = this.search
      const that = this
      if (!search) return this.optionList
      var regex = new RegExp(search.trim(), 'i')
      return _.filter(this.optionList, function (option) {
        return (regex.test(that.abbrevDict[option]) || regex.test(option)) && !that.isSelected(option)
      })
    }
  },
  mounted () {
    // pre populate options. This should really just be a prop that's from the parent component and shouldn't have a separate state here
    if (this.prePopulate.length > 0) {
      this.selected = this.prePopulate
    }
  },
  methods: {
    isSelected: function (option) {
      return this.selected.indexOf(option) !== -1
    },
    add: function (option) {
      const i = this.selected.indexOf(option)

      if (i === -1) this.selected.push(option)

      this.$emit('update', this.selected)
    },
    remove: function (option) {
      const i = this.selected.indexOf(option)
      if (i !== -1) this.selected.splice(i, 1)

      this.$emit('update', this.selected)
    },
    toggle: function (option) {
      const i = this.selected.indexOf(option)
      if (i === -1) {
        this.selected.push(option)
      } else {
        this.selected.splice(i, 1)
      }

      this.$emit('update', this.selected)
    },
    resetSearch: function () {
      this.search = ''
    }
  }
}
</script>

<style>
.prequal-checklist {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 5px;
  position: relative;
}

.prequal-checklist .search-input {
  width: 100%;
  border: 1px solid #375a8b;
  padding: 5px;
}

.prequal-checklist .toggle-dropdown {
  position: absolute;
  right: 5px;
  font-size: 16px;
  color: #05295c;
  cursor: pointer;
}

.prequal-checklist .toggle-dropdown i {
  cursor: pointer;
}

.prequal-checklist .display-buttons {
  display: flex;
  flex-wrap: wrap;
}

.prequal-checklist .search-item {
  min-height: 20px;
  color: #05295c;
  cursor: pointer;
}

.prequal-checklist .search-results {
  width: 100%;
  height: auto;
  max-height: 100px;
  overflow-y: scroll;
  border: 1px solid #eee;
  border-radius: 0 0 10px 10px;
}

.prequal-checklist .selected-item {
  display: inline-block;
  color: white;
  background-color: #05295c;
  padding: 3px 9px 3px 7px;
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  font-weight: 700;
}

.prequal-checklist .dropdown {
  width: 100%;
}

.prequal-checklist .item {
  min-height: 20px;
  display: inline-block;
  width: 50%;
  color: #05295c;
  vertical-align: top;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
